const skillsData = {
  headings: {
    languages: "Languages",
    subjects: "Subjects",
    technologies: "Technologies",
    frameworks: "Frameworks",
    softSkills: "Soft Skills",
  },
  languages: ["C", "Java", "C++", "MySQL"],
  subjects: [
    "Object Oriented Programming",
    "Database Management System",
    "Data Structures and Algorithm",
    "Operating System",
  ],
  technologies: ["MongoDB", "Node.js", "Express.js", "React"],
  frameworks: ["Tailwind CSS", "Bootstrap"],
  softSkills: ["Good Communication Skill", "Time Management", "Team Management"],
};

export default skillsData;
